import { render } from "./ParkingCordinator.vue?vue&type=template&id=a50a607a&scoped=true"
import script from "./ParkingCordinator.vue?vue&type=script&lang=js"
export * from "./ParkingCordinator.vue?vue&type=script&lang=js"

import "./ParkingCordinator.vue?vue&type=style&index=0&id=a50a607a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a50a607a"]])

export default __exports__